<template>
  <div class="tabs__model5">
    <b-card no-body class="row m-0">
      <b-tabs card v-model="tabindex">
        <b-tab
          active
          :id="custDetail && custDetail.service_head === 'AIR' ? 'tab__purple' : custDetail && custDetail.service_head === 'LAND' ? 'tab__deepgreen' : ''"
          >
          <template #title>
            <span class="d-flex align-items-center justify-content-center">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.59 12.9V16.97C15.59 17.33 15.55 17.67 15.46 17.98C15.09 19.45 13.87 20.37 12.19 20.37H9.47L6.45 22.38C6 22.69 5.4 22.36 5.4 21.82V20.37C4.38 20.37 3.53 20.03 2.94 19.44C2.34 18.84 2 17.99 2 16.97V12.9C2 11 3.18 9.69 5 9.52C5.13 9.51 5.26 9.5 5.4 9.5H12.19C14.23 9.5 15.59 10.86 15.59 12.9Z" :fill="tabindex === 0 ? 'white' :'#6E6E6E'"/>
                <path d="M17.75 16.1C19.02 16.1 20.09 15.68 20.83 14.93C21.58 14.19 22 13.12 22 11.85V6.75C22 4.4 20.1 2.5 17.75 2.5H9.25C6.9 2.5 5 4.4 5 6.75V7.5C5 7.78 5.22 8 5.5 8H12.19C14.9 8 17.09 10.19 17.09 12.9V15.6C17.09 15.88 17.31 16.1 17.59 16.1H17.75Z" :fill="tabindex === 0 ? 'white' :'#6E6E6E'"/>
              </svg>
              <strong class="directchat__topcontent--text">CHAT ROOM</strong>
            </span>
          </template>
          <b-card-text>
            <div class="directchat">
              <div class="directchat__content">
                <div class="align-items-end h-100">
                  <div class="col-md text-center" v-if="isLoadingMessages">
                    <b-spinner small variant="secondary"></b-spinner>
                  </div>
                  <div class="col-md p-0 test h-100" v-else-if="custDetail">
                    <div class="box__chatting global__scrollcustom"
                      :class="isDisableChat() ? 'box__disabled' : ''"
                      v-chat-scroll="{smooth: true, notSmoothOnInit: true}"
                    >
                      <div>
                        <div :class="getBubbleRowClass(message.sender.username)"  v-for="(message, index) in messages" :key="`${index}-A`">
                          <div :class="getBubbleColClass(message.sender.username)">
                            <div :class="getBubbleContent(message.sender.username)">
                              <!-- admin bubble -->
                              <div class="bubble__icon text-center"
                                  v-if="message.sender.username !== profile.customerUsername">
                                <img class="" v-if="message.sender.comptp === 'USER' && custDetail.service_head === 'AIR'"
                                src="@/assets/image/image/Customer Default Photo Air.png" alt="">
                                <img class="" v-else-if="message.sender.comptp === 'USER'"
                                src="@/assets/image/image/Customer Default Photo.png" alt="">
                                <img class="" v-else-if="message.sender.comptp === 'VENDOR'"
                                src="@/assets/image/image/Vendor Default Photo.png" alt="">
                                <img class="" v-else
                                src="@/assets/image/image/Admin Default Photo.png" alt="">
                                <p class="bubble__username">
                                    {{ message.sender.fullname ? message.sender.fullname
                                    : message.sender.username }}
                                </p>
                              </div>
                              <!-- end admin bubble -->
                              <div :class="getBubbleSizeClass(message.sender.username)">
                                <p :class="message.sender.username === profile.customerUsername
                                            ? 'time__bubble2' : 'time__bubble'">
                                  {{ getMessageDate(message.createdAt) }}
                                  <span>{{ getMessageTime(message.createdAt) }}</span>
                                </p>
                                <div :class="getBubbleColorClass(message.sender.username)">
                                  <div class="d-flex flex-row uploadfile"
                                  v-if="message.attachment !== null">
                                    <img :class="message.sender.username === profile.customerUsername
                                      ? 'uploadfile__icon' : ''" @click.prevent="downloadDoc(message.shipmentId, message.orderNumber, message.attachment.type.split('/')[ 0 ], message.attachment.type.split('/')[ 1 ], message.attachment.fileId)"
                                      :src="getIconFile(message.attachment.type)" alt="" height="28px">
                                    <div class="uploadfile pl-3">
                                      <p :class="message.sender.username === profile.customerUsername
                                            ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                            File Name: {{ message.attachment.type.replace("/","") }}</p>
                                      <p :class="message.sender.username === profile.customerUsername
                                            ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                          File Category: {{ message.attachment.fileDesc }}</p>
                                    </div>
                                  </div>
                                  <div v-if="message.attachment === null"
                                        :class="message.sender.username === profile.customerUsername && custDetail.service_head === 'AIR'
                                        ? 'bubble__text3' : message.sender.username === profile.customerUsername ? 'bubble__text2' : 'bubble__text'">
                                    <div v-if="message.replyOf && message.replyOf.body">
                                      <div class="row m-0 reply__mesage">
                                        <span>{{message.replyOf.from}}:</span>
                                        <span class="pl-1">{{message.replyOf.body}}</span>
                                      </div>
                                      {{removeOldReply(message.body)}}
                                    </div>
                                    <div v-else>{{message.body}}</div>
                                  </div>
                                  <!-- v-show="isHoveReplyMsg == index" -->
                                  <div :class="message.sender.username === profile.customerUsername
                                        ? 'bubble__reply2' : 'bubble__reply'" v-if="!isDisableChat()"
                                        @click.prevent="repplyMessages(message)">
                                    <img src="@/assets/image/icon/message-reply-arrow.svg" alt="">
                                    <p>Reply</p>
                                  </div>
                                </div>
                              </div>
  
                              <div class="bubble__icon mr-3 text-center"
                                    v-if="message.sender.username === profile.customerUsername">
                                <img class="" v-if="message.sender.username === profile.customerUsername && custDetail.service_head === 'AIR'"
                                src="@/assets/image/image/Customer Default Photo Air.png" alt="">
                                <img class="" v-else-if="message.sender.comptp === 'USER'"
                                src="@/assets/image/image/Customer Default Photo.png" alt="">
                                <img class="" v-else-if="message.sender.comptp === 'VENDOR'"
                                src="@/assets/image/image/Vendor Default Photo.png" alt="">
                                <img class="" v-else
                                src="@/assets/image/image/Admin Default Photo.png" alt="">
                                <p class="bubble__username2">
                                  {{ message.sender.fullname ? message.sender.fullname
                                  : message.sender.username }}
                                </p>
                              </div>
                              <!-- end your bubble -->
  
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="isReplyMsg" class="directchat__content--reply">
                      <span class="close" @click="resetMessage()">&times;</span>
                      <div class="reply__container">
                        <h5>{{replyOf.from}}</h5>
                        <h6>{{removeOldReply(replyOf.body)}}</h6>
                      </div>
                    </div>
                    <form id="sendmessages" @submit.prevent="sendMessages()">
                      <div class="row m-0 directchat__content--send"
                      :class="isDisableChat() ? 'chat__disabled' : ''">
                        <div class="col-md input" v-if="!isDisableChat()">
                          <div class="row m-0 input__container">
                            <b-form-textarea class=""
                              max-rows="3" v-model="text"
                              v-on:keyup="validateEmailAddress"
                              placeholder="Enter your message">
                            </b-form-textarea>
                            <div class="input__button">
                              <div class="button__upload">
                                <img src="@/assets/image/icon/chat-attachment.svg" alt=""
                                      @click="uploadfile()">
                              </div>
                              <button type="submit" name="button"
                                class="button__bluecorporite"
                                :disabled="removelinebreaks(text) === ''">
                                <img class=""  src="@/assets/image/icon/next.svg" alt="">
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="chat__disabled" v-else>
                          <p>Chat disabled , you can only view your history chat now</p>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab 
          title="Email" 
          :id="custDetail && custDetail.service_head === 'AIR' ? 'tab__purple' : custDetail && custDetail.service_head === 'LAND' ? 'tab__deepgreen' : ''"
          >
          <template #title>
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 13.5C3.24 13.5 1 15.73 1 18.5C1 21.27 3.24 23.5 6 23.5C8.76 23.5 11 21.26 11 18.5C11 15.74 8.77 13.5 6 13.5ZM3.96 16.46H6C6.38 16.46 6.68 16.77 6.68 17.14C6.68 17.51 6.38 17.82 6 17.82H3.96C3.58 17.82 3.28 17.51 3.28 17.14C3.28 16.77 3.58 16.46 3.96 16.46ZM8.04 20.54H3.96C3.58 20.54 3.28 20.23 3.28 19.86C3.28 19.49 3.59 19.18 3.96 19.18H8.05C8.43 19.18 8.73 19.49 8.73 19.86C8.73 20.23 8.42 20.54 8.04 20.54Z" :fill="tabindex === 1 ? 'white' :'#6E6E6E'"/>
              <path d="M17 3.5H7C4 3.5 2 5 2 8.5V11.64C2 12.37 2.75 12.83 3.42 12.54C4.52 12.06 5.77 11.88 7.08 12.09C9.7 12.52 11.84 14.59 12.37 17.19C12.52 17.95 12.54 18.69 12.44 19.4C12.36 19.99 12.84 20.51 13.43 20.51H17C20 20.51 22 19.01 22 15.51V8.5C22 5 20 3.5 17 3.5ZM17.47 9.09L14.34 11.59C13.68 12.12 12.84 12.38 12 12.38C11.16 12.38 10.31 12.12 9.66 11.59L6.53 9.09C6.21 8.83 6.16 8.35 6.41 8.03C6.67 7.71 7.14 7.65 7.46 7.91L10.59 10.41C11.35 11.02 12.64 11.02 13.4 10.41L16.53 7.91C16.85 7.65 17.33 7.7 17.58 8.03C17.84 8.35 17.79 8.83 17.47 9.09Z" :fill="tabindex === 1 ? 'white' :'#6E6E6E'"/>
            </svg>
            <strong class="directchat__topcontent--text">EMAIL</strong>
          </template>
          <b-card-text>
            <GroupChatEmail
              :requestID="rfqId || contractId"
              :requestNumber="rfqNumber || contractNumber"
              :requestType="rfqId ? 'RFQ' : 'CONTRACT'"
              :shipmentService="custDetail.service_head"
              :tabindex="tabindex"
            />
          </b-card-text>
        </b-tab>
      </b-tabs>

    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import * as momentTimezone from 'moment-timezone'
import mixinFileExt from '@/mixin/getters/file-extention'
import mixinGetStatus from '@/mixin/getters/status-bid'
import DOMPurify from 'dompurify'
import GroupChatEmail from '@/components/global/GroupChatEmail.vue'

export default {
  name: 'DirectChat',
  components: {
    GroupChatEmail
  },
  props: {
    custDetail: Object,
    typeRequest: String
  },
  data () {
    return {
      text: '',
      isReplyMsg: false,
      replyOf: {
        body: '',
        from: ''
      },
      rfqId: parseInt(this.$route.params.id_rfq, 10),
      rfqNumber: this.$route.params.rfqNumber,
      contractId: this.$route.params.id_contract,
      contractNumber: this.$route.params.contractNumber,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      checkdate: '',
      theday: '',
      totalActiveUser: 0,
      showUserList: false,
      tabindex: 0,
      shipmentService: ''
    }
  },
  mixins: [mixinFileExt, mixinGetStatus],
  computed: {
    ...mapGetters({
      // get user logged profile
      profile: 'auth/profile',
      // get chat messages
      messages: 'chat/messages',
      isLoadingMessages: 'chat/isLoadingMessages',
      errorMessages: 'chat/errorMessages',
      // get chat subscribers
      subscribers: 'chat/subscribers',
      isLoadingFetchSubscribers: 'chat/isLoadingFetchSubscribers',
      errorFetchSubscribers: 'chat/errorFetchSubscribers',
      // post chat subscribers
      isLoadingPostSubscribers: 'chat/isLoadingPostSubscribers',
      errorPostSubscribers: 'chat/errorPostSubscribers'
    })
  },
  watch: {
    '$route.params.rfq_id': function () {
      this.fetchChannelSubscribers()
    },
    subscribers (data) {
      if (data.length === 0) {
        this.postSubscribers()
      } else {
        this.fetchChannels()
      }
    }
  },
  mounted () {
    this.fetchChannelSubscribers()
  },
  methods: {
    validateEmailAddress (event) { // use shift + enter for break line, use enter for send
      if (event.keyCode === 13 && event.shiftKey === false) {
        this.sendMessages()
      }
    },
    isDisableChat () {
      if (this.custDetail) {
        return this.getStatus(this.custDetail) === 'Completed'
      }
    },
    removelinebreaks (text) {
      return text.replace(/[\r\n]+/gm, '')
    },
    uploadfile: function () {
      const id = this.rfqId || this.contractId
      const referenceNumber = this.rfqNumber ? this.rfqNumber.split('-').join('/') : this.contractNumber.split('-').join('/')
      const type = this.rfqId ? 'RFQ' : 'CONTRACT'
      this.$eventHub.$emit('dialog-upload-attachment', {id, referenceNumber, type})
    },
    getRowClass (username) {
      return username !== this.profile.customerUsername ? 'row ml-0 content__merchant' : 'row justify-content-end content__customer'
    },
    getBubbleRowClass (username) {
      return username !== this.profile.customerUsername ? 'content__merchant' : 'content__customer d-flex justify-content-end'
    },
    getBubbleColClass (username) {
      return username !== this.profile.customerUsername ? 'col-md p-0 pl-3' : 'col-md p-0'
    },
    getBubbleContent (username) {
      return username !== this.profile.customerUsername ? 'content__customer row m-0 mb-5 justify-content-start' : 'content__customer row justify-content-end m-0 mb-5'
    },
    getBubbleSizeClass (username) {
      return username !== this.profile.customerUsername ? 'content__customer bubble' : 'content__customer bubble bubblemargin'
    },
    getBubbleColorClass (username) {
      return username !== this.profile.customerUsername ? 'bg__gray' : this.custDetail && this.custDetail.service_head === 'AIR' ? 'bg__purple' : 'bg__blue'
    },
    getLoggedUser (fullname, userName, comptp) {
      let username = ''
      if (userName === this.profile.customerUsername && comptp !== 'GUEST') {
        username = this.profile.customerName
      } else if (userName === this.profile.customerUsername && comptp === 'GUEST') {
        username = this.profile.customerName || this.profile.customerUsername
      } else {
        username = fullname || userName
      }
      return username
    },
    getMessageTime (date) {
      const newTime = momentTimezone(date).tz(this.timezone).format('HH:mm')
      return newTime
    },
    getMessageDate (date) {
      const newDate = momentTimezone(date).tz(this.timezone).format('DD MMM YYYY')
      const today = momentTimezone().tz(this.timezone).format('DD MMM YYYY')
      if (today === newDate) {
        return 'Today'
      } else {
        return newDate
      }
    },
    getDate (date) {
      return moment(date).format('ddd, MMM DD')
    },
    checkDate (date) {
      if (moment(this.getDate(date), 'ddd, MMM DD').isValid()) {
        const iscurrentDate = moment(date).isSame(moment(), 'day')
        const duration = moment.duration({'days': 1})
        const isyesterday = moment(duration).isBefore(moment(), 'day')
        if (iscurrentDate) {
          return 'Today'
        } else if (isyesterday) {
          return 'Yesterday'
        } else {
          return this.getDate(date)
        }
      } else {
        return 'not found'
      }
    },
    showdate (date) {
      if (this.theday !== date) {
        this.theday = date
        return true
      } else {
        // this.theday = date
        return false
      }
    },
    fetchChannels () {
      const token = localStorage.getItem('token')
      const shipmentId = this.rfqId || this.contractId
      const orderNumber = this.rfqNumber ? this.rfqNumber.split('-').join('/') : this.contractNumber.split('-').join('/')
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS', { token, shipmentId, orderNumber }).then(() => {
        this.fetchMessages()
      })
    },
    fetchChannelSubscribers () {
      const shipmentId = this.rfqId || this.contractId
      const orderNumber = this.rfqNumber || this.contractNumber
      const typeMessage = this.rfqId ? 'quotation' : 'contract'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS', {shipmentId, orderNumber, typeMessage})
    },
    fetchMessages () {
      const shipmentId = this.rfqId || this.contractId
      const orderNumber = this.rfqNumber || this.contractNumber
      const typeMessage = this.rfqId ? 'quotation' : 'contract'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_MESSAGES', {shipmentId, orderNumber, typeMessage})
    },
    postSubscribers () {
      const typeMessage = this.rfqId ? 'quotation' : 'contract'
      const orderNumber = this.rfqNumber ? this.rfqNumber.split('-').join('/') : this.contractNumber.split('-').join('/')
      const payload = {
        shipmentId: this.rfqId ? parseInt(this.rfqId, 10) : parseInt(this.contractId, 10),
        orderNumber
      }
      this.$store.dispatch('chat/WEBSOCKET_POST_CHANNELS_SUBSCRIBERS', { payload, typeMessage }).then(() => {
        this.fetchChannels()
      })
    },
    resetMessage () {
      this.replyOf.from = ''
      this.replyOf.body = ''
      this.isReplyMsg = false
    },
    repplyMessages (message) {
      this.replyOf.body = message.body
      this.replyOf.from = message.sender.fullname
        ? message.sender.fullname : message.sender.username
      this.isReplyMsg = true
    },
    removeOldReply (message) { // remove tag just for display
      if (message.split('</p>')) {
        const arrBodysplittag = message.split('</p>')
        return arrBodysplittag[arrBodysplittag.length - 1]
      }
      return message
    },
    sendMessages () {
      if (this.removelinebreaks(this.text) !== '') {
        const typeMessage = this.rfqId ? 'quotation' : 'contract'
        const messageBody = DOMPurify.sanitize(this.text)
        const replyOf = Object.assign({}, this.replyOf)
        const payload = {
          messageBody,
          shipmentId: this.rfqId ? parseInt(this.rfqId, 10) : parseInt(this.contractId, 10),
          orderNumber: this.rfqNumber ? this.rfqNumber.split('-').join('/') : this.contractNumber.split('-').join('/'),
          reply: { to: 'admin' },
          replyOf
        }
        this.$store.dispatch('chat/WEBSOCKET_SEND_MESSAGE', { payload, typeMessage })
        this.messages.push({
          sender: {
            username: this.profile.customerUsername,
            fullname: this.profile.customerName,
            createdAt: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
            comptp: this.profile.compTp
          },
          body: messageBody,
          replyOf: this.isReplyMsg ? replyOf : null,
          attachment: null
        })
        this.text = ''
        this.resetMessage()
      }
    },
    downloadDoc (id, rfqNumber, fileCategory, fileExt, fileId) {
      const shipmentId = id
      const type = 'RFQ'
      const fileName = `${rfqNumber}_${fileCategory}${fileExt}`
      const orderNumber = rfqNumber.split('/').join('-')
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {shipmentId, orderNumber, type, fileName, fileCategory, fileId})
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    action: function (data) {
      const requestId = this.rfqId || this.contractId
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_MESSAGES') {
        if (data.payload.response.message.sender.username !== this.profile.customerUsername) {
          if ((data.payload.response.message.sender.comptp === 'ANDALIN' && data.payload.response.message.reply.to === 'customer' && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10)) || (data.payload.response.message.sender.comptp === 'USER' && data.payload.response.message.reply.to === 'admin' && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10))) {
            const newData = data.payload.response.message
            this.messages.push(newData)
          }
        }
      }
      if (data.type === 'RECEIVE_WEBSOCKET_UPDATE_SHIPMENT_DOCUMENTS') {
        if ((data.payload.response.message.sender.comptp === 'ANDALIN' && data.payload.response.message.reply.to === 'customer' && !data.payload.response.message.reply.vendorId && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10)) || (data.payload.response.message.sender.comptp === 'USER' && data.payload.response.message.reply.to === 'admin' && parseInt(data.payload.response.message.shipmentId, 10) === parseInt(requestId, 10))) {
          const newData = data.payload.response.message
          this.messages.push(newData)
          this.$eventHub.$emit('dialog-mgshipement-upload-hide')
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/GroupChat.vue